import { useState } from 'react'

import { useLangVoicesStore } from '@/lib/store/lang-voice-store'
import usePollyTextToSpeech from '@/utils/amazonPollyTextToSpeech'
import textToSpeech from '@/utils/textToSpeech'

export function useTTS({ text, audioUrl, language }: { audioUrl?: string; language?: string; text: string }) {
  const { pollyTextToSpeech, playUrlAudio, playing, currentWord, resume, pause } = usePollyTextToSpeech(text)
  const langVoices = useLangVoicesStore(store => store.langVoices)
  const loadingVoices = useLangVoicesStore(store => store.loading)

  const [statusPolly, setStatusPolly] = useState<'idle' | 'paused' | 'playing'>('idle')

  const startTTS = () => {
    if (audioUrl) {
      playUrlAudio(audioUrl)
    } else {
      if (langVoices && langVoices.length > 0) {
        if (playing && statusPolly === 'playing') {
          pause()
          setStatusPolly('paused')

          return
        }

        if (playing && statusPolly === 'paused') {
          resume()
          setStatusPolly('playing')

          return
        }

        // @ts-ignore
        pollyTextToSpeech(text)
        setStatusPolly('idle')
      } else if (!loadingVoices && !langVoices) {
        // @ts-ignore
        textToSpeech({
          text: text ?? '',
          language: language ?? '',
        })
      }
    }
  }

  return {
    startTTS,
    playing: (playing || statusPolly === 'playing') && !(statusPolly === 'paused'),
    currentWord,
  }
}
